import { useState, useEffect } from "react";
import apiFetch from "../../api/apiFetch";
import { BusinessHourEntry, DEFAULT_BUSINESS_HOURS, normalizeBusinessHours } from "../utils/businessHours";

export interface SiteContactSettings {
  contact_email: string;
  contact_phone: string;
  secondary_phone: string | null;
  map_url: string;
  address: string;
  business_hours: BusinessHourEntry[];
  facebook_url: string | null;
  instagram_url: string | null;
  youtube_url: string | null;
  linkedin_url: string | null;
  tiktok_url: string | null;
  twitter_url: string | null;
}

export const DEFAULT_SITE_CONTACT_SETTINGS: SiteContactSettings = {
  contact_email: "info@arteria-eg.com",
  contact_phone: "01117116067",
  secondary_phone: "01118321858",
  map_url: "https://maps.google.com/?q=9+Eshak+Yaekoob,+Almazah,+Heliopolis,+Cairo",
  address: "9 Eshak Yaekoob, Almazah, Heliopolis, Cairo",
  business_hours: DEFAULT_BUSINESS_HOURS,
  facebook_url: "https://web.facebook.com/arteria.eg",
  instagram_url: "https://www.instagram.com/arteria.eg",
  youtube_url: null,
  linkedin_url: null,
  tiktok_url: null,
  twitter_url: null,
};

// Shared across the Footer and the Contact page's "Get in Touch" section —
// both render the same admin-controlled contact info from one source of truth.
export function useSiteContactSettings(): SiteContactSettings {
  const [settings, setSettings] = useState<SiteContactSettings>(DEFAULT_SITE_CONTACT_SETTINGS);

  useEffect(() => {
    apiFetch("/footer-settings", { auth: false })
      .then((res: any) => {
        const raw = res?.data ?? res ?? {};
        setSettings({
          contact_email: raw.contact_email || DEFAULT_SITE_CONTACT_SETTINGS.contact_email,
          contact_phone: raw.contact_phone || DEFAULT_SITE_CONTACT_SETTINGS.contact_phone,
          secondary_phone: raw.secondary_phone ?? null,
          map_url: raw.map_url || DEFAULT_SITE_CONTACT_SETTINGS.map_url,
          address: raw.address || DEFAULT_SITE_CONTACT_SETTINGS.address,
          business_hours: raw.business_hours ? normalizeBusinessHours(raw.business_hours) : DEFAULT_BUSINESS_HOURS,
          facebook_url: raw.facebook_url ?? null,
          instagram_url: raw.instagram_url ?? null,
          youtube_url: raw.youtube_url ?? null,
          linkedin_url: raw.linkedin_url ?? null,
          tiktok_url: raw.tiktok_url ?? null,
          twitter_url: raw.twitter_url ?? null,
        });
      })
      .catch(() => {});
  }, []);

  return settings;
}
